import {reactFetchJSON} from '@github-ui/verified-fetch'
import {useCallback, useState} from 'react'

export type ProjectsWritableNoticeKey = 'repo_projects_beta_splash' | 'repo_projects_beta_banner'

/**
 * Local + persistent dismissal state for the projects welcome onboarding.
 */
export function useProjectsDismissibleNotices() {
  const [locally, setLocally] = useState<Partial<Record<ProjectsWritableNoticeKey, true>>>({})

  const dismissNotice = useCallback(async (notice: ProjectsWritableNoticeKey) => {
    // Optimistic: hide the UI before the network round-trip resolves.
    setLocally(prev => ({...prev, [notice]: true}))
    try {
      await reactFetchJSON(`/settings/dismiss-notice/${notice}`, {method: 'POST'})
    } catch {
      // Leave the local bit set on failure rather than re-showing the dismissed UI.
    }
  }, [])

  const isLocallyDismissed = useCallback((notice: ProjectsWritableNoticeKey) => Boolean(locally[notice]), [locally])

  return {isLocallyDismissed, dismissNotice}
}
